module.exports = "<footer class=\"main-footer\">\r\n  <!-- To the right -->\r\n  <div class=\"pull-right hidden-xs\">\r\n    Anything you want\r\n  </div>\r\n  <!-- Default to the left -->\r\n  <strong>Copyright &copy; 2019 <a href=\"https://jesusp.net\">JP</a>.</strong> All rights reserved.\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/projects/angular/DineroAgil/src/app/starter/starter-footer/starter-footer.component.html
// module id = ../../../../../src/app/starter/starter-footer/starter-footer.component.html
// module chunks = main